export default "__VITE_ASSET__de8dc43c__"